
import React from 'react';
import { CheckCircle, ArrowDown, Calculator } from 'lucide-react';

const TransparencySection: React.FC = () => {
  return (
    <section className="bg-white section">
      <div className="container">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">Transparante prijsberekening</h2>
          <p className="text-lg text-gray-600 mb-8">
            Met onze transparante prijsberekening weet je precies waar je aan toe bent. Geen verrassingen, enkel resultaat.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-brand-lightBlue/30 p-6 rounded-lg shadow-sm">
              <div className="text-brand-red mb-4">
                <CheckCircle size={36} />
              </div>
              <h3 className="font-semibold text-xl mb-3">Voorspelbare investering</h3>
              <p className="text-gray-600">
                We maken jouw investering voorspelbaar met duidelijke prijzen en geen verborgen kosten.
              </p>
            </div>
            
            <div className="bg-brand-lightBlue/30 p-6 rounded-lg shadow-sm">
              <div className="text-brand-red mb-4">
                <ArrowDown size={36} />
              </div>
              <h3 className="font-semibold text-xl mb-3">Lagere kosten</h3>
              <p className="text-gray-600">
                Volumekortingen en optimalisatie zorgen voor een steeds lagere leadprijs.
              </p>
            </div>
            
            <div className="bg-brand-lightBlue/30 p-6 rounded-lg shadow-sm">
              <div className="text-brand-red mb-4">
                <Calculator size={36} />
              </div>
              <h3 className="font-semibold text-xl mb-3">ROI-berekening</h3>
              <p className="text-gray-600">
                Bereken samen met ons de terugverdientijd en return-on-investment.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencySection;
